let currentToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? "";

export function getCsrfToken() {
  return currentToken;
}

export function setCsrfToken(token: string | null | undefined) {
  if (token) {
    currentToken = token;
  }
}
